import React from 'react';
import { ISocialLinks, ISocialProps } from '../../IFooter';
import SocialIcon from './social-icon';
import QuickLink from '../../../../basic/quickLink';
import { DataAnalytics, DataAnalyticsLocations, DataAnalyticsTypes, buildAnalytics } from '../../../../basic/analytics';

const Social = ({ socialItems, disclaimer }: ISocialProps): JSX.Element => {
  const { socialLinks, header, description, displaySocialMedia } = socialItems || {};

  return (
    <div className="flex flex-col xl:items-start">
      {displaySocialMedia &&
      <div className="py-4 text-sm xl:text-base text-white">
        <h3 className="font-extrabold pt-sm md:pt-0 text-secondary-400 hidden">{header}</h3>
        <div className="text-white">{description}</div>
        <div className="flex justify-start space-x-sm pt-5">
          {socialLinks?.map((ele: ISocialLinks, index: number) => {
            return <QuickLink href={ele.iconRoute?.href} isExternal key={index} dataAnalytics={buildAnalytics(DataAnalyticsLocations.Footer, DataAnalyticsTypes.Media,[DataAnalyticsLocations.Page])}
            aria-label={ele.iconRoute.title}>
                      <SocialIcon icon={ele.icon} key={`ft-so-${index}`} />
                    </QuickLink>
          })}
        </div>
      </div>
      }
      <div className="text-white text-sm xl:text-base py-4">{disclaimer}</div>
    </div>
  );
};

export default Social;
